import { observable } from 'mobx';
import StoresRepository, { IStoresRepositoryConfig } from '../StoresRepository';
import BopisFormInfo from '../../controllers/BopisViewController/BopisFormInfo';
import { IPurchaserInfo } from '../../domain/entities/Store/Store';
import Address, { AddressId, IAddressAttributes } from '../../domain/entities/Address';
import { INotificationResponse, IStoreInformation } from '../../api/IApiResponses';
import { NOTIFICATION_GROUP, NOTIFICATION_TYPE, SHIPPING_PAYMENT_NOTIFICATIONS } from '../../constants/Notifications';
import normalizeApiErrors from '../../helpers/normalizeApiErrors';
import { removePrefixForPhone } from '../../utils/AddressUtils';

export type IClickAndCollectConfig = IStoresRepositoryConfig;

export default class ClickAndCollectRepository extends StoresRepository {
  @observable bopisFormInfo: BopisFormInfo;

  constructor(props: IClickAndCollectConfig) {
    super(props);

    this.notificationsCollection = props.notificationsCollection;
  }

  public async setClickAndCollectAddress(
    purchaserDetails: IPurchaserInfo,
    store: IStoreInformation,
  ): Promise<Address> {

    try {

      if (!this.config.useE164PhoneStandard) {
        purchaserDetails.phone = removePrefixForPhone(
          purchaserDetails.phone,
          this.config.countryId,
        );
      }

      const response: {
        address?: IAddressAttributes;
        notifications?: INotificationResponse[];
      } = await this.api.setClickAndCollectStoreAddress({ purchaserDetails, store });

      if (response.notifications?.some(notification => notification.key === SHIPPING_PAYMENT_NOTIFICATIONS.SHIPPING_SET_TO_DEFAULT)) {
        this.notificationsCollection.addNotification({
          group: NOTIFICATION_GROUP.SHIPPING_PAYMENT,
          key: SHIPPING_PAYMENT_NOTIFICATIONS.SHIPPING_SET_TO_DEFAULT,
          timeout: 30000,
          type: NOTIFICATION_TYPE.WARNING,
        });
      }

      const newAddress = Address.fromJSON(response.address);

      return newAddress;
    } catch (error) {
      const normalizedErrors = normalizeApiErrors(error, NOTIFICATION_GROUP.SHIPPING);
      this.notificationsCollection.addNotifications(normalizedErrors);
      throw error;
    }
  }

  public async updateClickAndCollectAddress(
    purchaserDetails: IPurchaserInfo,
    store: IStoreInformation,
    id: AddressId,
  ): Promise<Address> {

    try {

      if (!this.config.useE164PhoneStandard) {
        purchaserDetails.phone = removePrefixForPhone(
          purchaserDetails.phone,
          this.config.countryId,
        );
      }

      const response: {
        address?: IAddressAttributes;
        notifications?: INotificationResponse[];
      } = await this.api.updateClickAndCollectStoreAddress({ purchaserDetails, store }, id);

      if (response.notifications?.some(notification => notification.key === SHIPPING_PAYMENT_NOTIFICATIONS.SHIPPING_SET_TO_DEFAULT)) {
        this.notificationsCollection.addNotification({
          group: NOTIFICATION_GROUP.SHIPPING_PAYMENT,
          key: SHIPPING_PAYMENT_NOTIFICATIONS.SHIPPING_SET_TO_DEFAULT,
          timeout: 30000,
          type: NOTIFICATION_TYPE.WARNING,
        });
      }

      const newAddress = Address.fromJSON(response.address);
  
      return newAddress;
    } catch (error) {
      const normalizedErrors = normalizeApiErrors(error, NOTIFICATION_GROUP.SHIPPING);
      this.notificationsCollection.addNotifications(normalizedErrors);
      throw error;
    }
  }
}
